import { useTradeDetailsView } from '@paradigm/features/src/unified-rfqs/ui/trades/details-view';
import BaseLegsTable from '#/components/UnifiedRfqs/components/LegsTable';
import { LegInfoCard } from '#/components/UnifiedRfqs/components/MobileLegsTable';
import { LegTableView } from '@paradigm/features/src/unified-rfqs/ui/types';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';

export default function TradeLegsTable() {
  const isMobile = useIsMobile();
  const view = useTradeDetailsView();
  const { legs } = view;

  return isMobile ? (
    <>
      {legs.map((leg) => (
        <LegInfoCard
          key={leg.index}
          legPricingEnabled
          hideMarkPrice
          legPrice={processLegPrice(leg)}
          isTwoWay={false}
          showContractTerms
          leg={leg}
        />
      ))}
    </>
  ) : (
    <BaseLegsTable showContractTerms {...view} />
  );
}
function processLegPrice(leg: LegTableView) {
  return {
    ask: leg.side === 'SELL' ? leg.price : null,
    bid: leg.side === 'BUY' ? leg.price : null,
    displayOnly: true,
    side: 'BUY',
  } as const;
}
